export default {
	tabs: ["出金", "履歴"],
	History: {
		tabs: ["審査中", "成功", "却下"]
	},
	Withdraw: {
		label: ["アカウント", "注文番号", "住所", "金額", "費用", "作成時間", "ステータス", "理由"]
	},
	AccountAmount: "口座残高",
	tips: "1時間以内に出金が行われます",
	form: {
		label: ["出金額", "取引パスワード"],
		ALL: "すべて",
		Withdraw: "提出"
	},
	WithdrawAccount: "口座の出金",
	noAccountsTips: "支払い方法を追加してください",
	tradingKind: [
		"キャッシュバック",
		"控除",
		"チャージ",
		"出金中",
		"出金解除",
		"出金",
		"タスク",
		"元本返却",
		"コミッション返却",
		"下位コミッション返却",
		"チェックイン",
		"手数料",
		"入金",
		"報酬",
		"基本給",
		"現金支援",
		"登録ボーナス",
		"商品配当",
		"タスクボーナス",
		"その他",
		"",
		"業務ボーナス",
		"アップグレード報酬",
		"補助金",
		"確認待ち",
		"キャンペーン",
		"ポイント交換",
		"ログイン報酬",
		"業務報酬",
		"信用スコア取引"
	]
};
